type buildBuiltRangeParams = {
  startDate?: string;
  endDate?: string;
  yearOnly?: boolean;
};

export const buildBuiltRange = ({
  startDate,
  endDate,
  yearOnly = false,
}: buildBuiltRangeParams) => {
  if (!startDate && !endDate) return null;
  if (!startDate)
    return yearOnly
      ? endDate?.split('T')[0].split('-')[0]
      : endDate?.split('T')[0];
  return yearOnly
    ? `${startDate?.split('T')[0].split('-')[0]} - ${
        endDate?.split('T')[0].split('-')[0] || 'unknown'
      }`
    : `${startDate?.split('T')[0]} - ${endDate?.split('T')[0] || 'unknown'}`;
};
